{
  "PROFILE_SETTINGS": {
    "LINK": "プロフィール設定",
    "TITLE": "プロフィール設定",
    "BTN_TEXT": "プロフィールを更新",
    "DELETE_AVATAR": "アバターを削除",
    "AVATAR_DELETE_SUCCESS": "アバターが正常に削除されました",
    "AVATAR_DELETE_FAILED": "アバターの削除中にエラーが発生しました。もう一度お試しください",
    "UPDATE_SUCCESS": "プロフィールが正常に更新されました",
    "PASSWORD_UPDATE_SUCCESS": "パスワードが正常に変更されました",
    "AFTER_EMAIL_CHANGED": "プロフィールが正常に更新されました。ログイン情報が変更されたため、再度ログインしてください。",
    "FORM": {
      "PICTURE": "プロフィール写真",
      "AVATAR": "プロフィール画像",
      "ERROR": "正しくフォームに入力してください",
      "REMOVE_IMAGE": "削除",
      "UPLOAD_IMAGE": "画像をアップロード",
      "UPDATE_IMAGE": "画像を更新",
      "PROFILE_SECTION": {
        "TITLE": "プロフィール",
        "NOTE": "あなたのメールアドレスはあなたのIDであり、ログインに使用されます。"
      },
      "SEND_MESSAGE": {
        "TITLE": "メッセージ送信のホットキー",
        "NOTE": "好みに応じて、EnterまたはCmd/Ctrl+Enterを選択できます。",
        "UPDATE_SUCCESS": "設定が正常に更新されました",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "送信ボタンをクリックせずにEnterキーでメッセージを送信します。"
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "送信ボタンをクリックせずにCmd/Ctrl+Enterキーでメッセージを送信します。"
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your Chatwoot dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "個人メッセージ署名",
        "NOTE": "送信するすべてのメッセージの末尾に表示されるユニークな署名を作成します。インライン画像を含めることができ、ライブチャット、メール、API受信トレイでサポートされています。",
        "BTN_TEXT": "署名を保存",
        "API_ERROR": "署名を保存できませんでした。もう一度お試しください。",
        "API_SUCCESS": "署名が正常に保存されました",
        "IMAGE_UPLOAD_ERROR": "画像をアップロードできませんでした。もう一度お試しください。",
        "IMAGE_UPLOAD_SUCCESS": "画像が正常に追加されました。保存をクリックして署名を保存してください。",
        "IMAGE_UPLOAD_SIZE_ERROR": "画像サイズは{size}MB未満である必要があります",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "メッセージ署名",
        "ERROR": "メッセージ署名を空にすることはできません",
        "PLACEHOLDER": "ここに個人のメッセージ署名を入力してください。"
      },
      "PASSWORD_SECTION": {
        "TITLE": "パスワード",
        "NOTE": "パスワードを更新すると、複数のデバイスでログインがリセットされます。",
        "BTN_TEXT": "パスワードを変更"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "ACCESS_TOKEN": {
        "TITLE": "アクセストークン",
        "NOTE": "このトークンは、API連携を構築する場合に利用します。",
        "COPY": "コピー",
        "RESET": "リセット",
        "CONFIRM_RESET": "Are you sure?",
        "CONFIRM_HINT": "Click again to confirm",
        "RESET_SUCCESS": "Access token regenerated successfully",
        "RESET_ERROR": "Unable to regenerate access token. Please try again"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "オーディオアラート",
        "NOTE": "ダッシュボードで新しいメッセージや会話の通知音を有効にします。",
        "PLAY": "音を再生",
        "ALERT_TYPES": {
          "NONE": "該当なし",
          "MINE": "割り当て済み",
          "ALL": "すべて",
          "ASSIGNED": "自分に割り当てられた会話",
          "UNASSIGNED": "未割り当ての会話",
          "NOTME": "他の人に割り当てられた会話"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "オプションが選択されていないため、通知音を受け取りません。",
          "ASSIGNED": "自分に割り当てられた会話の通知音を受け取ります。",
          "UNASSIGNED": "未割り当ての会話の通知音を受け取ります。",
          "NOTME": "他の人に割り当てられた会話の通知音を受け取ります。",
          "ASSIGNED+UNASSIGNED": "自分に割り当てられた会話と未割り当ての会話の通知音を受け取ります。",
          "ASSIGNED+NOTME": "自分と他の人に割り当てられた会話の通知音を受け取りますが、未割り当ての会話は含みません。",
          "NOTME+UNASSIGNED": "未割り当ての会話と他の人に割り当てられた会話の通知音を受け取ります。",
          "ASSIGNED+NOTME+UNASSIGNED": "すべての会話の通知音を受け取ります。"
        },
        "ALERT_TYPE": {
          "TITLE": "会話の通知イベント",
          "NONE": "該当なし",
          "ASSIGNED": "割り当てられた会話",
          "ALL_CONVERSATIONS": "すべての会話"
        },
        "DEFAULT_TONE": {
          "TITLE": "通知音:"
        },
        "CONDITIONS": {
          "TITLE": "通知条件:",
          "CONDITION_ONE": "ブラウザウィンドウがアクティブでない場合にのみ通知音を送信",
          "CONDITION_TWO": "割り当てられたすべての会話が既読になるまで30秒ごとに通知を送信"
        },
        "SOUND_PERMISSION_ERROR": "ブラウザで自動再生が無効になっています。通知音を自動で聞くには、ブラウザ設定で音声権限を有効にするか、ページと対話してください。",
        "READ_MORE": "詳細を読む"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Eメール通知",
        "NOTE": "メール通知設定を更新します",
        "CONVERSATION_ASSIGNMENT": "会話が自分に割り当てられたときにメール通知を送信",
        "CONVERSATION_CREATION": "新しい会話が作成されたときにメール通知を送信",
        "CONVERSATION_MENTION": "会話でメンションされたときにメール通知を送信",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "割り当てられた会話で新しいメッセージが作成されたときにメール通知を送信",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "参加している会話で新しいメッセージが作成されたときにメール通知を送信",
        "SLA_MISSED_FIRST_RESPONSE": "会話で最初の応答SLAを逃した場合にメール通知を送信",
        "SLA_MISSED_NEXT_RESPONSE": "会話で次の応答SLAを逃した場合にメール通知を送信",
        "SLA_MISSED_RESOLUTION": "会話で解決SLAを逃した場合にメール通知を送信"
      },
      "NOTIFICATIONS": {
        "TITLE": "通知設定",
        "TYPE_TITLE": "通知の種類",
        "EMAIL": "Eメール通知",
        "PUSH": "プッシュ通知",
        "TYPES": {
          "CONVERSATION_CREATED": "新しい会話が作成された時",
          "CONVERSATION_ASSIGNED": "会話が自分に割り当てられた時",
          "CONVERSATION_MENTION": "会話で自分がメンションされた時",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "割り当てられた会話に新しいメッセージが作成された時",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "参加している会話に新しいメッセージが作成された時",
          "SLA_MISSED_FIRST_RESPONSE": "会話で最初の応答SLAを逃した",
          "SLA_MISSED_NEXT_RESPONSE": "会話で次の応答SLAを逃した",
          "SLA_MISSED_RESOLUTION": "会話で解決SLAを逃した"
        },
        "BROWSER_PERMISSION": "プッシュ通知を受け取れるように、ブラウザの通知設定を有効にしてください"
      },
      "API": {
        "UPDATE_SUCCESS": "通知設定が正常に更新されました",
        "UPDATE_ERROR": "設定の更新中にエラーが発生しました。もう一度やり直してください。"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "プッシュ通知",
        "NOTE": "プッシュ通知の設定をここで更新します",
        "CONVERSATION_ASSIGNMENT": "会話が自分に割り当てられたときにプッシュ通知を送信",
        "CONVERSATION_CREATION": "新しい会話が作成されたときにプッシュ通知を送信",
        "CONVERSATION_MENTION": "会話でメンションされたときにプッシュ通知を送信",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "割り当てられた会話で新しいメッセージが作成されたときにプッシュ通知を送信",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "参加している会話で新しいメッセージが作成されたときにプッシュ通知を送信",
        "HAS_ENABLED_PUSH": "このブラウザーでプッシュ通知が有効になっています。",
        "REQUEST_PUSH": "プッシュ通知を有効にする",
        "SLA_MISSED_FIRST_RESPONSE": "会話で最初の応答SLAを逃したときにプッシュ通知を送信",
        "SLA_MISSED_NEXT_RESPONSE": "会話で次の応答SLAを逃したときにプッシュ通知を送信",
        "SLA_MISSED_RESOLUTION": "会話で解決SLAを逃したときにプッシュ通知を送信"
      },
      "PROFILE_IMAGE": {
        "LABEL": "プロフィール画像"
      },
      "NAME": {
        "LABEL": "あなたのフルネーム",
        "ERROR": "有効な氏名を入力してください",
        "PLACEHOLDER": "氏名を入力してください。"
      },
      "DISPLAY_NAME": {
        "LABEL": "表示名",
        "ERROR": "有効な表示名を入力してください",
        "PLACEHOLDER": "表示名を入力してください。これは会話に表示されます。"
      },
      "AVAILABILITY": {
        "LABEL": "利用可能期間",
        "STATUS": {
          "ONLINE": "オンライン",
          "BUSY": "取り込み中",
          "OFFLINE": "オフライン"
        },
        "SET_AVAILABILITY_SUCCESS": "利用可能ステータスが正常に設定されました",
        "SET_AVAILABILITY_ERROR": "利用可能ステータスを設定できませんでした。もう一度お試しください",
        "IMPERSONATING_ERROR": "Cannot change availability while impersonating a user"
      },
      "EMAIL": {
        "LABEL": "あなたのメールアドレス",
        "ERROR": "正しいメールアドレスを入力してください",
        "PLACEHOLDER": "メールアドレスを入力してください。これは会話に表示されます。"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "現在のパスワード",
        "ERROR": "現在のパスワードを入力してください",
        "PLACEHOLDER": "現在のパスワードを入力してください"
      },
      "PASSWORD": {
        "LABEL": "新しいパスワード",
        "ERROR": "6文字以上のパスワードを入力してください",
        "PLACEHOLDER": "新しいパスワードを入力してください"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "パスワードの確認",
        "ERROR": "パスワードは一致している必要があります",
        "PLACEHOLDER": "新しいパスワードを再度入力してください"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "ステータスを変更",
    "CHANGE_ACCOUNTS": "アカウントを切り替え",
    "SWITCH_ACCOUNT": "アカウントを切り替え",
    "CONTACT_SUPPORT": "サポートに問い合わせる",
    "SELECTOR_SUBTITLE": "次のリストからアカウントを選択してください",
    "PROFILE_SETTINGS": "プロフィール設定",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "キーボードショートカット",
    "APPEARANCE": "外観を変更",
    "SUPER_ADMIN_CONSOLE": "SuperAdminコンソール",
    "DOCS": "ドキュメントを読む",
    "CHANGELOG": "Changelog",
    "LOGOUT": "ログアウト"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "日間のトライアル期間が残っています。",
    "TRAIL_BUTTON": "今すぐ購入",
    "DELETED_USER": "削除済みユーザー",
    "EMAIL_VERIFICATION_PENDING": "メールアドレスがまだ認証されていないようです。受信トレイで認証メールを確認してください。",
    "RESEND_VERIFICATION_MAIL": "認証メールを再送",
    "EMAIL_VERIFICATION_SENT": "認証メールが送信されました。受信トレイを確認してください。",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "アカウント停止中",
      "MESSAGE": "アカウントが停止されています。詳細についてはサポートチームにお問い合わせください。"
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "ログアウト"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "コピー",
      "CODEPEN": "CodePenで開く",
      "COPY_SUCCESSFUL": "コードが正常にクリップボードにコピーされました"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "もっと見る",
      "SHOW_LESS": "閉じる"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "ダウンロード",
      "UPLOADING": "アップロード中...",
      "INSTAGRAM_STORY_UNAVAILABLE": "このストーリーはもう利用できません。",
      "INSTAGRAM_STORY_REPLY": "あなたのストーリーに返信:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "地図で見る"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "送信"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "この画像はもう利用できません。",
      "LOADING_FAILED": "読み込みに失敗しました"
    }
  },
  "CONFIRM_EMAIL": "確認中...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "受信トレイを追加"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "アイテムがありません",
    "CURRENTLY_VIEWING_ACCOUNT": "現在表示中のアカウント:",
    "SWITCH": "切り替え",
    "INBOX_VIEW": "受信トレイビュー",
    "CONVERSATIONS": "会話データ",
    "INBOX": "私の受信トレイ",
    "ALL_CONVERSATIONS": "すべての会話",
    "MENTIONED_CONVERSATIONS": "メンション",
    "PARTICIPATING_CONVERSATIONS": "参加中",
    "UNATTENDED_CONVERSATIONS": "未対応",
    "REPORTS": "レポート",
    "SETTINGS": "設定",
    "CONTACTS": "連絡先",
    "ACTIVE": "有効",
    "COMPANIES": "Companies",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "キャプテン",
    "CAPTAIN_ASSISTANTS": "アシスタント",
    "CAPTAIN_DOCUMENTS": "ドキュメント",
    "CAPTAIN_RESPONSES": "FAQ",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "受信トレイ",
    "CAPTAIN_SETTINGS": "設定",
    "HOME": "ホーム",
    "AGENTS": "担当者",
    "AGENT_BOTS": "ボット",
    "AUDIT_LOGS": "監査ログ",
    "INBOXES": "受信トレイ",
    "NOTIFICATIONS": "通知",
    "CANNED_RESPONSES": "定型文",
    "INTEGRATIONS": "連携",
    "PROFILE_SETTINGS": "プロフィール設定",
    "ACCOUNT_SETTINGS": "アカウント設定",
    "APPLICATIONS": "アプリケーション",
    "LABELS": "ラベル",
    "CUSTOM_ATTRIBUTES": "カスタム属性",
    "AUTOMATION": "自動化",
    "MACROS": "マクロ",
    "TEAMS": "チーム",
    "BILLING": "請求",
    "CUSTOM_VIEWS_FOLDER": "フォルダ",
    "CUSTOM_VIEWS_SEGMENTS": "セグメント",
    "ALL_CONTACTS": "すべての連絡先",
    "TAGGED_WITH": "タグ付け済み",
    "NEW_LABEL": "新しいラベル",
    "NEW_TEAM": "新しいチーム",
    "NEW_INBOX": "新しい受信トレイ",
    "REPORTS_CONVERSATION": "会話データ",
    "CSAT": "顧客満足度",
    "LIVE_CHAT": "ライブチャット",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "キャンペーン",
    "ONGOING": "進行中",
    "ONE_OFF": "単発",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "ボット",
    "REPORTS_AGENT": "担当者",
    "REPORTS_LABEL": "ラベル",
    "REPORTS_INBOX": "受信トレイ",
    "REPORTS_TEAM": "チーム",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "ステータスを設定",
    "SET_YOUR_AVAILABILITY": "利用可能ステータスを設定",
    "SLA": "SLA",
    "CUSTOM_ROLES": "カスタムロール",
    "BETA": "ベータ版",
    "REPORTS_OVERVIEW": "概要",
    "REAUTHORIZE": "受信トレイの接続期限が切れました。継続してメッセージを受信および送信するには、再接続してください。",
    "HELP_CENTER": {
      "TITLE": "ヘルプセンター",
      "ARTICLES": "記事",
      "CATEGORIES": "カテゴリー",
      "LOCALES": "言語",
      "SETTINGS": "設定"
    },
    "CHANNELS": "チャンネル",
    "SET_AUTO_OFFLINE": {
      "TEXT": "自動的にオフラインに設定",
      "INFO_TEXT": "アプリやダッシュボードを使用していない場合に、システムが自動的にオフラインに設定します。",
      "INFO_SHORT": "使用していない場合、自動的にオフラインにします。"
    },
    "DOCS": "ドキュメントを読む",
    "SECURITY": "Security",
    "CAPTAIN_AI": "キャプテン",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "アシスタント",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "機能",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts."
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "請求設定",
    "DESCRIPTION": "ここでサブスクリプションを管理し、プランをアップグレードしてチームにさらに多くの機能を提供しましょう。",
    "CURRENT_PLAN": {
      "TITLE": "現在のプラン",
      "PLAN_NOTE": "現在**{plan}**プランに**{quantity}**ライセンスでご加入中です。",
      "SEAT_COUNT": "シート数",
      "RENEWS_ON": "更新日"
    },
    "VIEW_PRICING": "料金を表示",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "サブスクリプションを管理",
      "DESCRIPTION": "過去の請求書を確認したり、請求情報を編集したり、サブスクリプションをキャンセルしたりできます。",
      "BUTTON_TXT": "請求ポータルへ"
    },
    "CAPTAIN": {
      "TITLE": "キャプテン",
      "DESCRIPTION": "Captain AIの使用状況とクレジットを管理する。",
      "BUTTON_TXT": "クレジットを追加購入する",
      "DOCUMENTS": "ドキュメント",
      "RESPONSES": "応答数",
      "UPGRADE": "Captainは無料プランでは利用できません。アシスタント、Copilotなどの機能を利用するには、プランをアップグレードしてください。",
      "REFRESH_CREDITS": "再読み込み"
    },
    "CHAT_WITH_US": {
      "TITLE": "サポートが必要ですか？",
      "DESCRIPTION": "請求に関する問題がありますか？お手伝いします。",
      "BUTTON_TXT": "チャットをする"
    },
    "NO_BILLING_USER": "請求アカウントを設定中です。ページを更新してもう一度お試しください。",
    "TOPUP": {
      "BUY_CREDITS": "クレジットを追加購入する",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Note:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "キャンセル",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "戻る",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "コードが正常にクリップボードにコピーされました",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "管理者にアップグレードを依頼してください。"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "今すぐアップグレード",
        "CANCEL_ANYTIME": "プランはいつでも変更またはキャンセルできます"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "属性を検索"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "会話を解決",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "会話を解決",
          "CANCEL": "キャンセル"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "オプションを選択"
        },
        "CHECKBOX": {
          "YES": "はい",
          "NO": "いいえ"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "今すぐアップグレード",
        "CANCEL_ANYTIME": "プランはいつでも変更またはキャンセルできます"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "管理者にアップグレードを依頼してください。"
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Chatwootアカウントが見つかりませんでした。続行するには新しいアカウントを作成してください。",
    "NEW_ACCOUNT": "新規アカウント",
    "SELECTOR_SUBTITLE": "新しいアカウントを作成",
    "API": {
      "SUCCESS_MESSAGE": "アカウントが正常に作成されました",
      "EXIST_MESSAGE": "アカウントはすでに存在します",
      "ERROR_MESSAGE": "Woot Serverに接続できませんでした。後でもう一度お試しください。"
    },
    "FORM": {
      "NAME": {
        "LABEL": "企業名",
        "PLACEHOLDER": "例: Wayne Enterprise"
      },
      "SUBMIT": "送信",
      "CANCEL": "キャンセル"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "すべてのショートカットを表示",
    "TITLE": {
      "OPEN_CONVERSATION": "会話を開く",
      "RESOLVE_AND_NEXT": "解決して次へ進む",
      "NAVIGATE_DROPDOWN": "ドロップダウン項目を移動",
      "RESOLVE_CONVERSATION": "会話を解決",
      "GO_TO_CONVERSATION_DASHBOARD": "会話ダッシュボードに移動",
      "ADD_ATTACHMENT": "添付ファイルを追加",
      "GO_TO_CONTACTS_DASHBOARD": "連絡先ダッシュボードに移動",
      "TOGGLE_SIDEBAR": "サイドバーを切り替え",
      "GO_TO_REPORTS_SIDEBAR": "レポートサイドバーに移動",
      "MOVE_TO_NEXT_TAB": "会話リスト内で次のタブに移動",
      "GO_TO_SETTINGS": "設定に移動",
      "SWITCH_TO_PRIVATE_NOTE": "プライベートメモに切り替え",
      "SWITCH_TO_REPLY": "返信に切り替え",
      "TOGGLE_SNOOZE_DROPDOWN": "スヌーズドロップダウンを切り替え"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "優先度",
          "ACTIVE": "有効",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "編集"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "キャンセル"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "説明:",
          "PLACEHOLDER": "説明を入力"
        },
        "STATUS": {
          "LABEL": "ステータス:",
          "PLACEHOLDER": "状況を選択",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Set the maximum number of conversations that can be assigned per agent within a time window to avoid overloading any one agent. This required field defaults to 100 conversations per hour.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select inboxes to add",
            "ADD_BUTTON": "追加"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "編集"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "キャンセル"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "説明:",
          "PLACEHOLDER": "説明を入力"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "追加"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "削除",
      "CANCEL_BUTTON_LABEL": "キャンセル"
    }
  }
}
